import type { Optional } from '@festina-life/core'

import {
  defaultExcludeKeys,
  stringifyComparableValue,
} from '../diffIndicators/helpers'
import type { SerialiseValueParams } from '../diffIndicators/ValueSetupDiffIndicators'
import type { SpecialCasedSubTemplatedValueSetup } from './types'

export const stringifySpecialCasedSubTemplateFieldValue = ({
  value: comparable,
}: SerialiseValueParams<SpecialCasedSubTemplatedValueSetup>) => {
  const comparableVariant = getSpecialCasedSubTemplatedFieldValue(comparable)

  if (!comparableVariant) {
    return ''
  }

  const excludeKeys = defaultExcludeKeys.filter((key) => key !== 'fields')

  return stringifyComparableValue(comparableVariant, excludeKeys)
}

export const getSpecialCasedSubTemplatedFieldValue = (
  fromField: Optional<SpecialCasedSubTemplatedValueSetup>,
) =>
  fromField?.field?.value?.variants.find(
    (variant) =>
      variant.subTemplateIdentifier === fromField.subTemplateIdentifier,
  )
